<template>
  <!-- Save your cart (guests, 2026-10-13). A guest's cart lives only in this browser, so one who
       leaves can't be reached. This emails them a link to it, once (SavedCartLink). An aside under
       the items, never in the way of Checkout. Hidden once this exact cart has been saved. -->
  <div v-if="visible" class="lf-savecart" data-track-area="cart.save">
    <template v-if="!sent">
      <div class="lf-savecart-lead"><strong>Not ready yet?</strong> Fish sell out. We'll email you a link to this cart.</div>
      <form class="lf-savecart-row" @submit.prevent="save">
        <label class="sr-only" for="lf-savecart-email">Email</label>
        <input id="lf-savecart-email" v-model="email" type="email" inputmode="email" autocomplete="email"
               placeholder="you@email.com" class="form-control form-control-sm" maxlength="254" required>
        <button type="submit" class="btn btn-outline-primary btn-sm" data-track="cart.save.submit" :disabled="sending">{{ sending ? 'Saving…' : 'Save cart' }}</button>
      </form>
      <div v-if="error" class="lf-savecart-error">{{ error }}</div>
      <div class="lf-savecart-small">One email with your cart link. No newsletter unless you ask for it.</div>
    </template>
    <div v-else class="lf-savecart-done">Saved. Check your inbox for the link{{ sentTo ? ' (' + sentTo + ')' : '' }}.</div>
  </div>
</template>

<script>
var SAVED_KEY = 'lf-cart-saved';

function readCart() {
  try { return JSON.parse(localStorage.getItem('lf-cart') || '[]') || []; } catch (e) { return []; }
}
function signature(items) {
  return items.map(function (i) { return i.productId + 'x' + i.quantity; }).sort().join(',');
}

export default {
  props: {
    hasAvailable: { type: Boolean, default: false }
  },
  data() {
    return { email: '', sending: false, sent: false, sentTo: '', error: '', alreadySaved: false };
  },
  computed: {
    visible() {
      return this.hasAvailable && (!this.alreadySaved || this.sent);
    }
  },
  mounted() {
    try { this.alreadySaved = localStorage.getItem(SAVED_KEY) === signature(readCart()); } catch (e) { }
    if (this.visible) {
      try {
        var body = JSON.stringify({ e: 'save_shown' });
        if (navigator.sendBeacon) navigator.sendBeacon('/cart/track', new Blob([body], { type: 'application/json' }));
      } catch (e) { }
    }
  },
  methods: {
    save() {
      var self = this;
      var items = readCart();
      if (!items.length) return;
      self.sending = true;
      self.error = '';
      fetch('/cart/save', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: self.email, items: items.map(function (i) { return { productId: i.productId, quantity: i.quantity, shippingTypeId: i.shippingTypeId || 0 }; }) })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { self.error = (res.d && res.d.error) || "That didn't send. Please try again."; return; }
          self.sent = true;
          self.sentTo = self.email.trim();
          try { localStorage.setItem(SAVED_KEY, signature(items)); } catch (e) { }
        })
        .catch(function () { self.error = "That didn't send. Please try again."; })
        .then(function () { self.sending = false; });
    }
  }
};
</script>

<style scoped>
.lf-savecart { background: #f3f7fe; border: 1px solid #c9daf5; border-radius: 10px; padding: 12px 14px; margin: 4px 0 16px; font-size: 14px; }
.lf-savecart-lead { color: #2a2f45; margin-bottom: 8px; }
.lf-savecart-lead strong { color: #333957; }
.lf-savecart-row { display: flex; gap: 6px; max-width: 440px; }
.lf-savecart-row input { flex: 1 1 auto; min-width: 0; }
.lf-savecart-row button { font-weight: 800; white-space: nowrap; }
.lf-savecart-small { font-size: 12px; color: #8b90a5; margin-top: 6px; }
.lf-savecart-error { font-size: 13px; color: #b02a37; margin-top: 6px; }
.lf-savecart-done { color: #1a6b34; font-weight: 700; }
</style>
